import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// import { useForm } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';
// import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { colorPalette, defaultLegendItemCountToShow } from '../../../_services/essentials/constants';
// import { StyledText } from '../../../_services/essentials/functions/custom_style';
import { masterProfilesActions as myActions, breadcrumbsActions } from '../../../_services/essentials/store';
import { Stack } from '@mui/material';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import { Tab, Tabs } from "@mui/material";
import PropTypes from 'prop-types';
import { BarChart } from "@mui/x-charts/BarChart";
import { styled } from "@mui/material/styles";
import { PieChart } from "@mui/x-charts/PieChart";
// import { useDrawingArea } from "@mui/x-charts/hooks";
import Grid from "@mui/material/Grid";
import { DataGrid, GridPagination} from "@mui/x-data-grid";
//import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import Tooltip from '@mui/material/Tooltip';
import { TagCloud } from 'react-tagcloud'
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import NewspaperOutlinedIcon from '@mui/icons-material/NewspaperOutlined';
import ReactCountryFlag from "react-country-flag"
import CircularProgress from '@mui/material/CircularProgress';
import FeedIcon from '@mui/icons-material/Feed';
//import { SocialIcon } from 'react-social-icons'
import SocialmediaIcon from '../../../_components/internals/components/socialmedia-icons/SocialmediaIcon';
import {history} from "../../../_services/essentials/helpers";
import ListItemButton from '@mui/material/ListItemButton';

//export { ViewProfile };

export const ViewProfile = function() {
    //    const entity_name = "profile";
    //    const entity_label = "Profile";
    const entities_name = "Profiles";
    //    const entities_label = "Profiles";

    const { id } = useParams();
    const dispatch = useDispatch();
    const entity = useSelector(x => x.masterProfiles?.item);
    const educationQualifications = useSelector(x => x.masterProfiles?.education_qualifications);
    const professionalActivities = useSelector(x => x.masterProfiles?.professional_activities);
    const honorAndAwards = useSelector(x => x.masterProfiles?.honor_and_awards);
    const press = useSelector(x => x.masterProfiles?.press);
    const publication = useSelector(x => x.masterProfiles?.publication);

    //Start: Chart Data
    const [chartPubCategoryData, setChartPubCategoryData] = useState([]);
    const [chartPubSeriesData, setChartPubSeriesData] = useState([]);
    const [chartHeightForPublication, setChartHeightForPublication] = useState(300);
    const [chartLegendHeightForPublication, setChartLegendHeightForPublication] = useState(50);

    const [chartEventCategoryData, setChartEventCategoryData] = useState([]);
    const [chartEventSeriesData, setChartEventSeriesData] = useState([]);
    const [chartHeightForEvent, setChartHeightForEvent] = useState(300);
    const [chartLegendHeightForEvent, setChartLegendHeightForEvent] = useState(50);

    //    const [chartClinicalTrialCategoryData, setChartClinicalTrialCategoryData] = useState([]);
    const [chartClinicalTrialSeriesData, setChartClinicalTrialSeriesData] = useState([]);

    const [chartSocialMediaCategoryData, setChartSocialMediaCategoryData] = useState([]);
    const [chartSocialMediaSeriesData, setChartSocialMediaSeriesData] = useState([]);
    const [chartHeightForSocialMedia, setChartHeightForSocialMedia] = useState(300);
    const [chartLegendHeightForSocialMedia, setChartLegendHeightForSocialMedia] = useState(50);
    //End:

    const [keywordMetricsData, setKeywordMetricsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [socialMediaAccounts, setSocialMediaAccounts] = useState([]);
    // form validation rules

    const [selectedTab, setSelectedTab] = useState(0);

    const [scientificPubLoading, setScientificPubLoading] = useState(true);
    const [onLoadWait, setOnLoadWait] = useState(true);

    const [showAllPublicationsLegendItem, setShowAllPublicationsLegendItem] = useState(false);
    const [showAllEventsLegendItem, setShowAllEventsLegendItem] = useState(false);
    const [showAllSocialMediaLegendItem, setShowAllSocialMediaLegendItem] = useState(false);

    const LegendItem = ({ color, label }) => {
        return (
            <Stack direction={'row'} sx={{mr: 2, height: '30px', verticalAlign:'middle'}}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <circle cx="4.5" cy="4.8689" r="18" fill={color} />8
                </svg>
                <Typography sx={{mx: 1, fontSize: '14px'}}>{label}</Typography>
            </Stack>
        );
    };

    dispatch(breadcrumbsActions.setCurrentTitle(`Profile`));

    dispatch(breadcrumbsActions.setCurrentURL({
        url: history.location?.pathname,
        state: history.location?.state
    }));

    const handleTabChange = async (event, newValue) => {
        setSelectedTab(newValue);
        // newValue === 0 ? setSelectedTabColor('#FFF')
        //     : (newValue === 1 ? setSelectedTabColor('#FFF')
        //         : setSelectedTabColor('#F3F3F3')
        //     );

        if (newValue === 1) {
            if (id) {
//                if (educationQualifications === null)
                    dispatch(myActions.getEducationQualificationsByFilter(educationQualificationPageFilter)).unwrap().then(entity => { });
//                if (professionalActivities === null)
                    dispatch(myActions.getProfessionalActivitiesByFilter(professionalActivityPageFilter)).unwrap().then(entity => { });
//                if (honorAndAwards === null)
                    dispatch(myActions.getHonorAndAwardsByFilter(honorAndAwardPageFilter)).unwrap().then(entity => { });
            }
        }

        if (newValue === 2) {
            if (id) {
                dispatch(myActions.getPressByFilter(pressPageFilter)).unwrap().then(entity => { });
                setScientificPubLoading(true);
                await dispatch(myActions.getPublicationByFilter(publicationPageFilter)).unwrap().then(entity => { });
                setScientificPubLoading(false);
            }
        }

    };

    const educationQualificationFilter = {
        "educationQualificationFilter": {
            profileId: id
        }
    };
    const educationQualificationPageFilter = {
        "pageNumber": 1,
        "pageSize": 100000,
        "dataFilter": educationQualificationFilter
    };

    const professionalActivityFilter = {
        "professionalActivityFilter": {
            profileId: id
        }
    };

    const professionalActivityPageFilter = {
        "pageNumber": 1,
        "pageSize": 100000,
        "dataFilter": professionalActivityFilter
    };

    const honorAndAwardFilter = {
        "honorAndAwardFilter": {
            profileId: id
        }
    };

    const honorAndAwardPageFilter = {
        "pageNumber": 1,
        "pageSize": 100000,
        "dataFilter": honorAndAwardFilter
    };

    // eslint-disable-next-line
    const [pressFilter, setPressFilter] = useState({
        "pressFilter": {
            profileId: id
        }
    });

    const pressPageFilter = {
        "pageNumber": 1,
        "pageSize": 100000,
        "sortField": "date, topic",
        "sortDirection": "desc, asc",
        "dataFilter": pressFilter
    };

    // eslint-disable-next-line
    const [publicationFilter, setPublicationFilter]  = useState({
        "publicationFilter": {
            profileId: id
        }
    });

    const publicationPageFilter = {
        "pageNumber": 1,
        "pageSize": 100000,
        "sortField": "publicationYear, articleChapterTitle",
        "sortDirection": "desc, asc",
        "dataFilter": publicationFilter
    };

    const columnsForPublication = [
        {
            field: 'articleChapterTitle',
            renderHeader: () => (<h6><strong>{'Topic'}</strong></h6>),
            flex: 1,
            minWidth: 550,
            maxWidth: 650,
            renderCell: (params) =>
                <Stack sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'normal',
                }}>
                    <Typography variant="body1" sx={{}}>{params.value}</Typography>
                </Stack>
        },
        {
            field: 'publicationYear',
            renderHeader: () => (<h6><strong>{'Date'}</strong></h6>),
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            minWidth: 200,
            maxWidth: 300,
            renderCell: (params) =>
                <Typography sx={{mt: 1, fontFamily: 'Arial'}}>{params.value}</Typography>
        },
        {
            field: 'url',
            renderHeader: () => (<h6><strong>{'Link'}</strong></h6>),
            headerAlign: 'center',
            align: 'left',
            flex: 1,
            minWidth: 350,
            maxWidth: 450,
            renderCell: (params) =>
                <Tooltip title={params.row.url}>
                    <Stack sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'normal',
                        verticalAlign: 'middle'
                    }}>
                        <Typography variant="body1" sx={{
                            cursor: 'pointer',
                            color: 'blue',
                            mt: 1,
                        }} onClick={() => { window.open(params.row.url, '_blank', 'noopener') }} >{params.value}</Typography>
                    </Stack>
                </Tooltip>
        }

    ];

    const columnsForPress = [
        {
            field: 'topic',
            renderHeader: () => (<h6><strong>{'Headline'}</strong></h6>),
            flex: 1,
            minWidth: 550,
            maxWidth: 650,
            renderCell: (params) =>

                <Tooltip title={params.row.url}>
                    <Stack sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'normal',
                    }}>
                        <Typography variant="body1" sx={{
                            cursor: 'pointer',
                            color: 'blue',
                        }} onClick={() => { window.open(params.row.url, '_blank', 'noopener') }} >{params.value}</Typography>
                    </Stack>
                </Tooltip>
            // <HtmlTooltip title={params.value} placement="top" sx={{ fontSize: '18px' }} >
            //             <Stack direction="row" sx={{
            //                 py: 1, alignItems: 'center', width: '100%'
            //             }}>
            //                  const textEllipsis = {


            // };
            //                 <Stack direction="column"
            //                     justifyContent="center"
            //                     alignItems="left"  >
            //                     <Typography variant="body1" sx={{
            //                         cursor: 'pointer'

            //                     }} onClick={() => { window.open(params.row.url, '_blank', 'noopener') }} >{params.value}</Typography>
            //                 </Stack>
            //             </Stack>
            // </HtmlTooltip>
            // <Link to={`${params.row.url}`} >{params.value}</Link>
        },
        {
            field: 'date',
            renderHeader: () => (<h6><strong>{'Date'}</strong></h6>),
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            minWidth: 200,
            maxWidth: 300,
            renderCell: (params) =>
                <Typography sx={{mt: 1, fontFamily: 'Arial'}}>{params.value}</Typography>
        },
        {
            field: 'scientificPlatform',
            renderHeader: () => (<h6><strong>{'Source'}</strong></h6>),
            headerAlign: 'left',
            align: 'left',
            flex: 1,
            minWidth: 350,
            maxWidth: 450,
            renderCell: (params) =>
                <Typography sx={{mt: 1}}>{params.value}</Typography>
        }

    ];

    function customFooter() {
        return (
            <CustomGridPagination />
        );
    }

    const CustomGridPagination = styled(({ className, ...props }) => (
        // <GridPagination {...props} sx={{mt: 10, mb: 10, color: red}} componentsProps={{ Typography: {className: className} }} />
         <GridPagination {...props} sx={{mt: 2}}/>
    ))(``);

    // function PieCenterLabel({ primaryText, secondaryText }) {
    //     const { width, height, left, top } = useDrawingArea();
    //     const primaryY = top + height / 2 - 10;
    //     const secondaryY = primaryY + 24;
    //
    //     return (
    //         <React.Fragment>
    //             <StyledText variant="primary" x={left + width / 2} y={primaryY}>
    //                 {primaryText}
    //             </StyledText>
    //             <StyledText variant="secondary" x={left + width / 2} y={secondaryY}>
    //                 {secondaryText}
    //             </StyledText>
    //         </React.Fragment>
    //     );
    // }

    // const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    //     <Tooltip {...props} classes={{ popper: className }} />
    // ))(({ theme }) => ({
    //     [`& .${tooltipClasses.tooltip}`]: {
    //         backgroundColor: '#ffffcc',
    //         color: 'rgba(0, 0, 0, 1)',
    //         width: 750,
    //         fontSize: theme.typography.pxToRem(16),
    //         border: '1px solid #000033',
    //     },
    // }));

    function CustomTabPanel(props) {
        const { children, value, backgroundColor, index, ...other } = props;

        return (
            <Box
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index &&
                    <Stack direction="column" sx={{
                        // background: backgroundColor,
                        // border: '0px solid #0052eb',
                        // borderColor: '#777',
                        // backdropFilter: 'blur(1px)',
                        // borderRadius: '16px'
                    }}>
                        {children}
                    </Stack>
                }
            </Box>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const [chartPubDataResponseData, setChartPubDataResponseData] = useState(null);
    const [chartEventDataResponseData, setChartEventDataResponseData] = useState(null);
    const [chartClinicalTrialDataResponseData, setChartClinicalTrialDataResponseData] = useState(null);
    const [chartSocialMediaDataResponseData, setChartSocialMediaDataResponseData] = useState(null);

    useEffect(() => {
        if (id) {
            if(!onLoadWait) {
                console.log('actualy loaded on id modified');
                setLoading(true);
                dispatch(myActions.getById(id));
                loadCharts(id, selectedTab);
                loadKeywordMeterics(id);
                loadSocialMediaAccounts(id);
                setLoading(false);
            }
        }
    }, [id, onLoadWait]);

    useEffect(() => {
        if(onLoadWait){
            const timeoutId = setTimeout(() => {
                setOnLoadWait(false);
            }, 200);

            return () => clearTimeout(timeoutId);
        }
    }, [onLoadWait]);

    // async function loadCharts(id, selectedTab) {
    //     const chart_limit = 5;
    //     if (selectedTab === 0) {
    //         if (!chartPubDataResponseData)
    //             setChartPubDataResponseData(await dispatch(myActions.getChartPubData({ id, chart_limit })));
    //         if (!chartEventDataResponseData)
    //             setChartEventDataResponseData(await dispatch(myActions.getChartEventData({ id, chart_limit })));
    //         if (!chartClinicalTrialDataResponseData)
    //             setChartClinicalTrialDataResponseData(await dispatch(myActions.getChartClinicalTrialData({ id, chart_limit })));
    //         if (!chartSocialMediaDataResponseData)
    //             setChartSocialMediaDataResponseData(await dispatch(myActions.getChartSocialMediaData({ id, chart_limit: 10 })));

    //     }
    // }
    async function loadCharts(id, selectedTab) {
        const chart_limit = 5;
        if (selectedTab === 0) {
            const [pubData, eventData, trialData, socialMediaData] = await Promise.all([
                chartPubDataResponseData === null
                    ? dispatch(myActions.getChartPubData({ id, chart_limit }))
                    : Promise.resolve(null),
                chartEventDataResponseData === null
                    ? dispatch(myActions.getChartEventData({ id, chart_limit }))
                    : Promise.resolve(null),
                chartClinicalTrialDataResponseData === null
                    ? dispatch(myActions.getChartClinicalTrialData({ id, chart_limit }))
                    : Promise.resolve(null),
                chartSocialMediaDataResponseData === null
                    ? dispatch(myActions.getChartSocialMediaData({ id, chart_limit: 10 }))
                    : Promise.resolve(null),
            ]);

            setChartPubDataResponseData(pubData || chartPubDataResponseData);
            setChartEventDataResponseData(eventData || chartEventDataResponseData);
            setChartClinicalTrialDataResponseData(trialData || chartClinicalTrialDataResponseData);
            setChartSocialMediaDataResponseData(socialMediaData || chartSocialMediaDataResponseData);
        }
    }

    async function loadKeywordMeterics(id) {
        if(id) {
        if (!keywordMetricsData || (keywordMetricsData && keywordMetricsData.length===0) ) {
            setKeywordMetricsData(await dispatch(myActions.getKeywordMetricsData({id})));
        }
    }
    }


    async function loadSocialMediaAccounts(id) {
        if(id) {
        if (!socialMediaAccounts || (socialMediaAccounts && socialMediaAccounts.length===0) ) {
            setSocialMediaAccounts(await dispatch(myActions.getSocialMediaAccounts({id})));
        }
    }
    }

    useEffect(() => {
        const chartPubDataResponse = chartPubDataResponseData?.payload;
        if (chartPubDataResponse) {
            let chartPubSeriesDataJSONArray = [];
            setChartPubCategoryData([
                {
                    scaleType: 'band',
                    categoryGapRatio: (1/(chartPubDataResponse?.categoryData?.length))+0.2,
                    //barGapRatio: 0.8,
                    data: chartPubDataResponse?.categoryData,
                    label: 'Years',
                    labelStyle: {
                        transform: 'translateY(10px)',
                    },
                },
            ]);
            for (const key in chartPubDataResponse?.seriesData) {
                chartPubSeriesDataJSONArray.push(
                    {
                        id: `${key}-views`,
                        label: key,
                        data: chartPubDataResponse?.seriesData[key],
                        color: colorPalette[chartPubSeriesDataJSONArray.length],
                        stack: 'A',
                    }
                );

                setChartPubSeriesData(chartPubSeriesDataJSONArray);
            }
            // const chartSeriesLength = Object.keys(chartPubDataResponse?.seriesData).length;
            // if(chartSeriesLength>100) {
            //     setChartHeightForPublication(chartSeriesLength * 20);
            //     setChartLegendHeightForPublication(chartSeriesLength * 15);
            // } else if(chartSeriesLength>28) {
            //     setChartHeightForPublication(chartSeriesLength*28);
            //     setChartLegendHeightForPublication(chartSeriesLength*16);
            // } else if(chartSeriesLength>10) {
            //     setChartHeightForPublication(820);
            //     setChartLegendHeightForPublication(410);
            // }
        }
    }, [chartPubDataResponseData]);

    useEffect(() => {
        const chartEventDataResponse = chartEventDataResponseData?.payload;
        if (chartEventDataResponse) {
            let chartEventSeriesDataJSONArray = [];
            setChartEventCategoryData([
                {
                    scaleType: 'band',
                    categoryGapRatio: (1/(chartEventDataResponse?.categoryData?.length))+0.2,
                    barGapRatio: 0.8,
                    data: chartEventDataResponse?.categoryData,
                    label: 'Years',
                    labelStyle: {
                        transform: 'translateY(10px)',
                    },

                },
            ]);
            for (const key in chartEventDataResponse?.seriesData) {
                chartEventSeriesDataJSONArray.push(
                    {
                        id: `${key}-views`,
                        label: key,
                        data: chartEventDataResponse?.seriesData[key],
                        color: colorPalette[chartEventSeriesDataJSONArray.length],
                        stack: 'A',
                    }
                );
                setChartEventSeriesData(chartEventSeriesDataJSONArray);
            }
            // const chartSeriesLength = Object.keys(chartEventDataResponse?.seriesData).length;
            // if(chartSeriesLength>100) {
            //     setChartHeightForEvent(chartSeriesLength * 20);
            //     setChartLegendHeightForEvent(chartSeriesLength * 15);
            // } else if(chartSeriesLength>28) {
            //     setChartHeightForEvent(chartSeriesLength*28);
            //     setChartLegendHeightForEvent(chartSeriesLength*16);
            // } else if(chartSeriesLength>10) {
            //     setChartHeightForEvent(820);
            //     setChartLegendHeightForEvent(410);
            // }
        }
    }, [chartEventDataResponseData]);
    useEffect(() => {
        const chartClinicalTrialDataResponse = chartClinicalTrialDataResponseData?.payload;
        if (chartClinicalTrialDataResponse && chartClinicalTrialDataResponse.seriesData) {

            let chartClinicalTrialSeriesDataJSONArray = [];
            for (const key in chartClinicalTrialDataResponse.seriesData) {
                chartClinicalTrialSeriesDataJSONArray.push(
                    {
                        //id: `${key}-views`,
                        label: key,
                        value: chartClinicalTrialDataResponse.seriesData[key],
                    }
                );

                setChartClinicalTrialSeriesData([
                    {
                        arcLabel: (item) => `${item.value}`,
                        arcLabelMinAngle: 25,
                        // arcLabelRadius: 75,
                        data: chartClinicalTrialSeriesDataJSONArray,
                        innerRadius: 55,
                        outerRadius: 100,
                        paddingAngle: 0,
                        highlightScope: { faded: 'global', highlighted: 'item' },
                    },
                ]);
            }
        }
    }, [chartClinicalTrialDataResponseData]);
    useEffect(() => {
        const chartSocialMediaDataResponse = chartSocialMediaDataResponseData?.payload;
        if (chartSocialMediaDataResponse) {
            let chartSocialMediaSeriesDataJSONArray = [];
            setChartSocialMediaCategoryData([
                {
                    scaleType: 'band',
                    categoryGapRatio: (1/(chartSocialMediaDataResponse?.categoryData?.length))+0.2,
                    barGapRatio: 0.8,
                    data: chartSocialMediaDataResponse?.categoryData,
                    label: 'Social Media Platform',
                    labelStyle: {
                        transform: 'translateY(10px)',
                    },
                },
            ]);
            for (const key in chartSocialMediaDataResponse?.seriesData) {
                chartSocialMediaSeriesDataJSONArray.push(
                    {
                        id: `${key}-views`,
                        label: key,
                        data: chartSocialMediaDataResponse?.seriesData[key],
                        color: colorPalette[chartSocialMediaSeriesDataJSONArray.length],
                        stack: 'A',
                    }
                );
                setChartSocialMediaSeriesData(chartSocialMediaSeriesDataJSONArray);
            }
            // const chartSeriesLength = Object.keys(chartSocialMediaDataResponse?.seriesData).length;
            // if(chartSeriesLength>100) {
            //     setChartHeightForSocialMedia(chartSeriesLength * 20);
            //     setChartLegendHeightForSocialMedia(chartSeriesLength * 15);
            // } else if(chartSeriesLength>28) {
            //     setChartHeightForSocialMedia(chartSeriesLength*28);
            //     setChartLegendHeightForSocialMedia(chartSeriesLength*16);
            // } else if(chartSeriesLength>10) {
            //     setChartHeightForSocialMedia(820);
            //     setChartLegendHeightForSocialMedia(410);
            // }
        }
    }, [chartSocialMediaDataResponseData]);

    const columnsForEducation = [
        {
            field: 'institutionName',
            renderHeader: () => (<h6><strong>{'Institution'}</strong></h6>),
            flex: .9,
            // minWidth: 450,
            renderCell: (params) =>
                <Stack direction="row" sx={{
                    py: 1, width: '100%'
                }}>
                    <Stack direction="column">
                        <Typography component="h2" variant="body2" sx={{}}>
                            {params.row.institutionName ? params.row.institutionName : ''}
                        </Typography>
                    </Stack>
                </Stack>
        },
        {
            field: 'educationType',
            renderHeader: () => (<h6><strong>{'Education'}</strong></h6>),
            // headerAlign: 'center',
            // align: 'center',
            flex: .4,
            // minWidth: 150,
            renderCell: (params) =>
                <Stack direction="row" sx={{
                    py: 1, width: '100%'
                }}>
                    <Stack direction="column">
                        <Typography component="h2" variant="body2" sx={{}}>
                            {params.row.educationType ? params.row.educationType : ''}
                        </Typography>
                    </Stack>
                </Stack>
        },
        {
            field: 'degree',
            renderHeader: () => (<h6><strong>{'Degree'}</strong></h6>),
            // headerAlign: 'center',
            // align: 'center',
            flex: .4,
            // minWidth: 150,
            renderCell: (params) =>
                <Stack direction="row" sx={{
                    py: 1, width: '100%'
                }}>
                    <Stack direction="column">
                        <Typography component="h2" variant="body2" sx={{}}>
                            {params.row.degree ? params.row.degree : ''}
                        </Typography>
                    </Stack>
                </Stack>
        },
        {
            field: 'year',
            renderHeader: () => (<h6><strong>{'Year'}</strong></h6>),
            // headerAlign: 'center',
            align: 'center',
            flex: .3,
            // minWidth: 100,

            renderCell: (params) =>
                <Stack direction="row" sx={{
                    py: 1, width: '100%'
                }}>
                    <Stack direction="column">
                        <Typography component="h2" variant="body2" sx={{}}>
                            {params.row.startDate ? parseInt(params.row.startDate) : ''}
                            {(params.row.startDate && params.row.endDate) ? ' - ' : null}
                            {params.row.endDate ? parseInt(params.row.endDate) : null}
                        </Typography>
                    </Stack>
                </Stack>
        }

    ];
    const columnsForProfessional = [
        {
            field: 'organizationName',
            renderHeader: () => (<h6><strong>{'Affiliation'}</strong></h6>),
            flex: 1,
            // minWidth: 450,
            renderCell: (params) =>
                <Stack direction="row" sx={{
                    py: 1, width: '100%'
                }}>
                    <Stack direction="column">
                        <Typography component="h2" variant="body2" sx={{}}>
                            {params.row.organizationName ? params.row.organizationName : ''}
                        </Typography>
                    </Stack>
                </Stack>
        },
        {
            field: 'boardCommittee',
            renderHeader: () => (<h6><strong>{'Department'}</strong></h6>),
            // headerAlign: 'center',
            // align: 'center',
            flex: .7,
            // minWidth: 50,
            renderCell: (params) =>
                <Stack direction="row" sx={{
                    py: 1, alignItems: 'center', width: '100%'
                }}>
                    <Stack direction="column"
                           justifyContent="center"
                           alignItems="left"  >
                        <Typography component="h2" variant="body2">
                            {params.row.boardCommittee}
                        </Typography>
                    </Stack>
                </Stack>
        },
        {
            field: 'positionRole',
            renderHeader: () => (<h6><strong>{'Role'}</strong></h6>),
            // headerAlign: 'center',
            // align: 'center',
            flex: .5,
            // minWidth: 50,
            renderCell: (params) =>
                <Stack direction="row" sx={{
                    py: 1, alignItems: 'center', width: '100%'
                }}>
                    <Stack direction="column"
                        justifyContent="center"
                        alignItems="left">
                        <Typography component="h2" variant="body2">
                            {params.row.positionRole}
                        </Typography>
                    </Stack>
                </Stack>
        },
        /*TODO: Remove this code after Mar 20, 2025 */
        // {
        //     field: 'year',
        //     renderHeader: () => (<h6><strong>{'Year'}</strong></h6>),
        //     // headerAlign: 'center',
        //     // align: 'center',
        //     flex: .3,
        //     // minWidth: 50,
        //     renderCell: (params) =>
        //         <Stack direction="row" sx={{
        //             py: 1, alignItems: 'center', width: '100%'
        //         }}>
        //             <Stack direction="column"
        //                 justifyContent="center"
        //                 alignItems="left"  >
        //                 <Typography component="h2" variant="body2">
        //                     {params.row.endDate ? parseInt(params.row.endDate) : ''}
        //                     {/*{params.row.startDate ? parseInt(params.row.startDate) : ''}*/}
        //                     {/*{(params.row.startDate && params.row.endDate) ? '-' : null}*/}
        //                     {/*{params.row.endDate ? parseInt(params.row.endDate) : null}*/}
        //                 </Typography>
        //             </Stack>
        //         </Stack>
        // }
    ];
    const columnsForAchievement = [
        {
            field: 'awardName',
            renderHeader: () => (<h6><strong>{'Award'}</strong></h6>),
            flex: 1,
            minWidth: 200,
            renderCell: (params) =>
                <Stack direction="row" sx={{
                    py: 1, width: '100%'
                }}>
                    <Stack direction="column">
                        <Typography component="h2" variant="body2" sx={{}}>
                            {params.row.awardName ? params.row.awardName : ''}
                        </Typography>
                    </Stack>
                </Stack>
        },
        {
            field: 'awardingBodyName',
            renderHeader: () => (<h6><strong>{'Awarded by'}</strong></h6>),
            flex: 1,
            minWidth: 250,
            renderCell: (params) =>
                <Stack direction="row" sx={{
                    py: 1, width: '100%'
                }}>
                    <Stack direction="column">
                        <Typography component="h2" variant="body2" sx={{}}>
                            {params.row.awardingBodyName ? params.row.awardingBodyName : ''}
                        </Typography>
                    </Stack>
                </Stack>
        },
        {
            field: 'year',
            renderHeader: () => (<h6><strong>{'Year'}</strong></h6>),
            // headerAlign: 'center',
            // align: 'center',
            flex: .3,
            minWidth: 100,
            renderCell: (params) =>
                <Stack direction="column" sx={{
                    py: 1, width: '100%'
                }}>
                    <Stack direction="column"
                           justifyContent="center"
                           alignItems="left"
                    >
                        <Typography component="h2" variant="body2" sx={{}}>
                            {params.row.year ? params.row.year : ''}
                        </Typography>
                    </Stack>
                </Stack>
        },
    ];

    return (
        !(entity?.loading || entity?.error) && (entity && entity.value) &&
        <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '100%' } }}>
            {loading ? (<div
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    height: '80%'
                    // zIndex: 1,
                }}
            >
                <CircularProgress />
            </div>) : (
                <Stack direction="row" sx={{ width: '100%', }}>

                    <Stack direction="column" sx={{ width: '30%', pr: '2%' }}>
                        <Stack direction="row" sx={{ py: 1, alignItems: 'center' }}>
                            <Stack direction="column"
                                justifyContent="center"
                                alignItems="left"
                            >
                                <Avatar
                                    sizes="small"
                                    alt={`${entity?.value.firstname} ${entity?.lastname}`}
                                    src={entity?.value.profileImage?.imageLink}
                                    sx={{ width: 120, height: 120 }}
                                    href={`/${entities_name}/view/${entity?.id}`}
                                />
                            </Stack>
                            <Stack direction="column" sx={{ ml: 2, justifyContent: 'left' }}>
                                <Typography component="h6" variant="subtitle1" gutterBottom sx={{fontWeight: 'bold'}}>
                                    {entity?.value.salutation} {entity?.value.firstname} {entity?.value.lastname} {entity?.value.suffix}
                                    {/* <strong>{entity?.value.salutation} {entity?.value.firstname} {entity?.value.lastname} {entity?.value.suffix}</strong> */}
                                </Typography>
                                <Stack direction="column" sx={{ gap: 1, mt:2, alignItems: 'left' }}>
                                    <Typography variant="subtitle2">
                                        <span style={{ fontWeight: 600, color: '#201747' }}>Role: </span>
                                        <span style={{ color: '#1b1b79' }}>{entity?.value.title}</span>
                                    </Typography>
                                    <Typography variant="subtitle2" >
                                        <span style={{ fontWeight: 600, color: '#201747' }}>Affiliation: </span>
                                        {entity?.value.primaryAffiliation}
                                    </Typography>
                                    <Typography variant="subtitle2">
                                        <span style={{ fontWeight: 600, color: '#201747' }}>Department: </span>
                                        {entity?.value.department}
                                    </Typography>
                                    <Stack direction={"row"} sx={{minWidth: '80px'}}>
                                        <Stack sx={{verticalAlign: 'center', mt:0.25}}>
                                            <Typography variant="subtitle2" sx={{ minWidth: '80px' }}>
                                                <span style={{ fontWeight: 600, color: '#201747' }}>Career Status: </span>
                                                {entity?.value.careerStatus}
                                            </Typography>
                                        </Stack>
                                        <Stack sx={{ml:1}}>
                                        {(entity?.value.careerStatus === 'Peak' &&
                                            <img
                                                src="/assets/images/healthcare/peak.png"
                                                alt="Peak"
                                                style={{ height: '24px' }}
                                            />
                                        )}
                                        {(entity?.value.careerStatus === 'Rising Star' &&
                                            <img
                                                src="/assets/images/healthcare/rising_star.png"
                                                alt="Rising Star"
                                                style={{ height: '24px' }}
                                            />
                                        )}
                                        </Stack>
                                    </Stack>
                                    {(socialMediaAccounts?.payload && Array.prototype.isPrototypeOf(socialMediaAccounts?.payload) && socialMediaAccounts?.payload.length>0) &&
                                    <Stack direction="row" sx={{mr: 1, mb:0, gap:1, justifyContent: 'left', flexGrow: '1', flexWrap: 'wrap' }}>
                                        <Typography variant="subtitle2" sx={{mt:0, mb:1}}>
                                            <span style={{fontWeight: 600, color: '#201747'}}>Social Media: </span>
                                        </Typography>
                                        {/*Reference: https://www.npmjs.com/package/react-social-icons*/}
                                        {/*Reference: https://github.com/couetilc/react-social-icons*/}
                                        {socialMediaAccounts?.payload?.map((socialMediaAccount) => (
                                            <SocialmediaIcon smapp={socialMediaAccount?.socialMediaApp} socialMediaUrl={socialMediaAccount?.socialMediaUrl} />
                                        ))
                                        }
                                    </Stack>
                                    }
                                </Stack>
                            </Stack>
                        </Stack>
                        <Stack direction="column" sx={{}}>
                            <Typography variant="caption"  >
                                <span style={{ fontWeight: 600, color: '#201747' }}>
                                    Email:
                                </span>  {entity?.value.primaryEmail}
                            </Typography>
                            <Typography variant="caption"  >
                                <span style={{ fontWeight: 600, color: '#201747' }}>
                                    Phone:
                                </span>  {entity?.value.phone}
                            </Typography>
                            <Typography variant="caption"  >
                                <span style={{ fontWeight: 600, color: '#201747' }}>
                                    Area of Specialty:
                                </span>  {entity?.value.specialty}
                            </Typography>
                            <Typography variant="caption"  >
                                <span style={{ fontWeight: 600, color: '#201747' }}>
                                    Language:
                                </span>  {entity?.value.languages}
                            </Typography>
                            <Typography variant="caption"  >
                                <span style={{ fontWeight: 600, color: '#201747' }}>
                                    KOL Type:
                                </span> {entity?.value.profession}
                            </Typography>
                            <Typography variant="caption" sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                            }}>
                                <span style={{ fontWeight: 600, color: '#201747', paddingRight: '3px' }}>
                                    Country:
                                </span>
                                {/* {(entity?.value.country === 'USA' &&
                                <SquareUsaFlag />
                            )}
                            {(entity?.value.country === 'Brazil' && <BrazilFlag />)}
                            {(entity?.value.country === 'India' && <IndiaFlag />)}
                            {(!['', 'USA', 'Brazil', 'India'].includes(entity?.value.country) && <SquareUsaFlag />)}
                            {entity?.value.country} */}

                                <ReactCountryFlag
                                    countryCode={entity?.value.countryRef?.code}
                                    svg
                                    style={{
                                        width: "20px",
                                        height: "20px",
                                    }}
                                    title={entity?.value.countryRef?.name}
                                />
                                {entity?.value.countryRef?.name}
                            </Typography>
                        </Stack>
                        <Stack direction="row" sx={{ mt: 2, mb: 1 }}>
                            <Typography variant="body2" sx={{ fontWeight: 600, color: '#201747' }} >
                                Address
                            </Typography>
                        </Stack>
                        <Stack direction="column" sx={{}}>
                            <Typography variant="caption">
                                {entity?.value.address1}
                            </Typography>
                            <Typography variant="caption">
                                {entity?.value.address2}
                            </Typography>
                            <Typography variant="caption">
                                {entity?.value.city}
                            </Typography>
                            <Typography variant="caption">
                                {entity?.value.state}
                            </Typography>
                            <Typography variant="caption">
                                {entity?.value.postalCode ? parseInt(entity?.value.postalCode) : ''}
                            </Typography>
                        </Stack>
                        {/*<Stack direction="row" sx={{ mt: 2, mb: 1 }}>*/}
                        {/*    <Typography variant="body2" sx={{ fontWeight: 600, color: '#201747' }} >*/}
                        {/*        Area of Focus*/}
                        {/*    </Typography>*/}
                        {/*</Stack>*/}
                        {/*<Stack direction="column" sx={{}}>*/}
                        {/*    <Typography variant="caption">*/}
                        {/*        {entity?.value.areasOfInterests}*/}
                        {/*    </Typography>*/}
                        {/*</Stack>*/}
                        {(keywordMetricsData?.payload && Array.prototype.isPrototypeOf(keywordMetricsData?.payload)) &&
                        <Stack direction="column">
                            <Stack direction="column" sx={{ mt: 2, mb: 1 }}>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#201747' }} >
                                    {/*Keyword Metrics*/}
                                    Area of Focus
                                </Typography>
                            </Stack>
                            <Stack direction="column" sx={{}}>
                                <TagCloud
                                    minSize={10}
                                    maxSize={25}
                                    tags={keywordMetricsData?.payload}
                                    colorOptions={{
                                        luminosity: 'blue',
                                        hue: 'red',
                                    }}
                                    //onClick={tag => console.log(`'${tag.value}' was selected!`)}
                                />
                            </Stack>
                        </Stack>
                        }
                        <Stack direction="row" sx={{ mt: 2, mb: 1 }}>
                            <Typography variant="body2" sx={{ fontWeight: 600, color: '#201747' }} >
                                KOL Summary
                            </Typography>
                        </Stack>
                        <Stack direction="column"  >
                            <Typography component="h2" variant="caption" sx={{ textAlign: 'justify' }}>
                                {entity?.value.bioSummary}
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack direction="column" sx={{ width: '70%' }}>
                        <Stack>
                            {/* Tabs */}
                            <Box sx={{ width: '100%' }}>
                                <Tabs
                                    value={selectedTab}
                                    onChange={handleTabChange}
                                    indicatorColor="none"
                                    textColor="primary"
                                    sx={{
                                        ".MuiTabs-indicator": {
                                            display: "none",
                                        },
                                        borderRadius: 0,
                                        backgroundColor: '#F6F8FB',
                                        width: '100%',
                                    }}
                                >
                                    <Tab
                                        label="Dashboard"
                                        {...a11yProps(0)}
                                        sx={{
                                            minWidth: '33%',
                                            fontSize: '20px',
                                            fontWeight: selectedTab === 0 ? 'bold' : 'normal',
                                        }}
                                    />
                                    <Tab
                                        label="Portfolio"
                                        {...a11yProps(1)}
                                        sx={{
                                            minWidth: '33%',
                                            fontSize: '20px',
                                            fontWeight: selectedTab === 1 ? 'bold' : 'normal',
                                        }}
                                    />
                                    <Tab
                                        label="Radar"
                                        {...a11yProps(1)}
                                        sx={{
                                            minWidth: '34%',
                                            fontSize: '20px',
                                            fontWeight: selectedTab === 2 ? 'bold' : 'normal',
                                        }}
                                    />
                                </Tabs>
                            </Box>
                            {/* Tab Panels */}
                            <CustomTabPanel value={selectedTab} index={0}>
                                <Stack direction="row" spacing={1} sx={{ gap: 1, mt: 3 }}>
                                    <Stack
                                        direction="column"
                                        sx={{
                                            flex: 1, // Equal distribution
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            gap: 1,
                                            background: '#F6F8FB',
                                            backdropFilter: 'blur(1px)',
                                            borderRadius: '12px',
                                            //height: `${chartHeightForPublication}px`
                                        }}
                                    >
                                        <Typography component="h2" sx={{ mt: 1, fontSize: '16px', fontWeight: 'bold' }}>
                                            Publications
                                        </Typography>
                                        <BarChart
                                            borderRadius={8}
                                            colors={colorPalette}
                                            xAxis={chartPubCategoryData}
                                            series={chartPubSeriesData}
                                            yAxis={[
                                                {
                                                  //  valueFormatter: (value) => `${(value / 1000).toLocaleString()}k`,
                                                    label: 'Key Topics count',
                                                    labelStyle: {
                                                        transform: 'translateY(25%), translateX(-145px), rotate(-90deg)',
                                                    },
                                                },
                                            ]}
                                            barLabel={(item, context) => {
                                                // if ((item.value ?? 0) > 10) {
                                                //     return 'High';
                                                // }
                                                return context.bar.height < 20 ? null : item.value?.toString();
                                            }}
                                            height={chartHeightForPublication}
                                            margin={{ left: 50, right: 10, top: 30, bottom: chartLegendHeightForPublication }}
                                            grid={{ horizontal: true }}
                                            sx={{ mb: 2, ml: 2, mr: 2 }}
                                            slotProps={{
                                                legend: {
                                                    hidden: true,
                                                },
                                            }}
                                        />
                                        <Stack direction="row" sx={{width: '90%', minHeight: '125px', flexGrow: '1', flexWrap: 'wrap'}}>
                                            {
                                                chartPubSeriesData.slice(0, defaultLegendItemCountToShow).map((d, idx) => <LegendItem
                                                        color={d.color}
                                                        label={d.label}
                                                    />
                                                )
                                            }
                                            {
                                                showAllPublicationsLegendItem && chartPubSeriesData.slice(defaultLegendItemCountToShow).map((d, idx) => <LegendItem
                                                        //  color={colors[idx + defaultLegendItemCountToShow]}
                                                        color={d.color}
                                                        label={d.label}
                                                    />
                                                )
                                            }
                                            <Stack sx={{height: '100%'}}></Stack>
                                        </Stack>
                                        {(chartPubSeriesData.length > defaultLegendItemCountToShow) ? (
                                        <ListItemButton sx={{fontSize: '12px'}} onClick={() => setShowAllPublicationsLegendItem(prev => !prev)}>{showAllPublicationsLegendItem ? 'Minimize Legend View' : 'Expand Legend View'}</ListItemButton>
                                        ):(
                                            <Stack sx={{height: '35px'}}></Stack>
                                        )
                                        }
                                    </Stack>
                                    <Stack
                                        direction="column"
                                        sx={{
                                            flex: 1, // Equal distribution
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            gap: 1,
                                            background: '#F6F8FB',
                                            backdropFilter: 'blur(1px)',
                                            borderRadius: '12px',
                                            //height: `${chartHeightForEvent}px`
                                        }}
                                    >
                                        <Typography component="h2" sx={{ mt: 1, fontSize: '16px', fontWeight: 'bold' }}>
                                            Events
                                        </Typography>
                                        <BarChart
                                            borderRadius={8}
                                            colors={colorPalette}
                                            xAxis={chartEventCategoryData}
                                            series={chartEventSeriesData}
                                            yAxis={[
                                                {
                                                    //valueFormatter: (value) => `${(value / 1000).toLocaleString()}k`,
                                                    label: 'Keywords count',
                                                    labelStyle: {
                                                        transform: 'translateY(25%), translateX(-145px), rotate(-90deg)',
                                                    },
                                                },
                                            ]}
                                            barLabel={(item, context) => {
                                                // if ((item.value ?? 0) > 10) {
                                                //     return 'High';
                                                // }
                                                return context.bar.height < 20 ? null : item.value?.toString();
                                            }}
                                            height={chartHeightForEvent}
                                            margin={{ left: 50, right: 10, top: 30, bottom: chartLegendHeightForEvent }}
                                            grid={{ horizontal: true }}
                                            sx={{ mb: 2, ml: 2, mr: 2 }}
                                            slotProps={{
                                                legend: {
                                                    hidden: true,
                                                },
                                            }}
                                        />
                                        <Stack direction="row" sx={{width: '90%', minHeight: '125px', flexGrow: '1', flexWrap: 'wrap'}}>
                                            {
                                                chartEventSeriesData.slice(0, defaultLegendItemCountToShow).map((d, idx) => <LegendItem
                                                        color={d.color}
                                                        label={d.label}
                                                    />
                                                )
                                            }
                                            {
                                                showAllEventsLegendItem && chartEventSeriesData.slice(defaultLegendItemCountToShow).map((d, idx) => <LegendItem
                                                        //  color={colors[idx + defaultLegendItemCountToShow]}
                                                        color={d.color}
                                                        label={d.label}
                                                    />
                                                )
                                            }
                                            <Stack sx={{height: '100%'}}></Stack>
                                        </Stack>
                                        {(chartEventSeriesData.length > defaultLegendItemCountToShow) ? (
                                        <ListItemButton sx={{fontSize: '12px'}} onClick={() => setShowAllEventsLegendItem(prev => !prev)}>{showAllEventsLegendItem ? 'Minimize Legend View' : 'Expand Legend View'}</ListItemButton>
                                        ):(
                                            <Stack sx={{height: '35px'}}></Stack>
                                        )
                                        }
                                    </Stack>
                                </Stack>
                                <Stack direction="row" spacing={1} sx={{ gap: 1, mt: 3 }}>
                                    <Stack
                                        direction="column"
                                        sx={{
                                            flex: 1, // Equal distribution
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            gap: 1,
                                            background: '#F6F8FB',
                                            backdropFilter: 'blur(1px)',
                                            borderRadius: '12px',
                                        }}
                                    >
                                        <Typography component="h2" sx={{ mt: 1, fontSize: '16px', fontWeight: 'bold' }}>
                                            Clinical Trials
                                        </Typography>
                                        {(chartClinicalTrialSeriesData && chartClinicalTrialSeriesData.length > 0) &&
                                                <PieChart
                                                    colors={colorPalette}
                                                    margin={{
                                                        left: 60,
                                                        right: 60,
                                                        top: 60,
                                                        bottom: 140,
                                                    }}
                                                    series={chartClinicalTrialSeriesData}
                                                    height={400}
                                                    slotProps={{
                                                        legend: {
                                                            hidden: false,
                                                            direction: "row",
                                                            position: { vertical: 'bottom', horizontal: 'middle' },
                                                            labelStyle: {
                                                                fontSize: 14,
                                                                // fill: 'blue',
                                                            }
                                                        },
                                                    }}
                                                >
                                                    {/*<PieCenterLabel primaryText="98.5K" secondaryText="Total" />*/}
                                                </PieChart>
                                        }
                                        <Stack sx={{ minHeight: '125px'}}></Stack>
                                        {!(chartClinicalTrialSeriesData && chartClinicalTrialSeriesData.length > 0) &&
                                        <Typography component="h6" sx={{ mt: 14, fontSize: '13px' }}>
                                            No data to display
                                        </Typography>
                                        }
                                    </Stack>
                                    <Stack
                                        direction="column"
                                        sx={{
                                            flex: 1, // Equal distribution
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            gap: 1,
                                            background: '#F6F8FB',
                                            backdropFilter: 'blur(1px)',
                                            borderRadius: '12px',
                                            //height: `${chartHeightForSocialMedia}px`
                                        }}
                                    >
                                        <Typography component="h2" sx={{ mt: 1, fontSize: '16px', fontWeight: 'bold' }}>
                                            Social Media Analysis
                                        </Typography>
                                        <BarChart
                                            borderRadius={8}
                                            colors={colorPalette}
                                            xAxis={chartSocialMediaCategoryData}
                                            series={chartSocialMediaSeriesData}
                                            yAxis={[
                                                {
                                                    //valueFormatter: (value) => `${(value / 1000).toLocaleString()}k`,
                                                    label: 'Keywords count',
                                                    labelStyle: {
                                                        transform: 'translateY(25%), translateX(-145px), rotate(-90deg)',
                                                    },
                                                },
                                            ]}
                                            barLabel={(item, context) => {
                                                // if ((item.value ?? 0) > 10) {
                                                //     return 'High';
                                                // }
                                                return context.bar.height < 20 ? null : item.value?.toString();
                                            }}
                                            height={chartHeightForSocialMedia}
                                            margin={{ left: 50, right: 10, top: 30, bottom: chartLegendHeightForSocialMedia }}
                                            grid={{ horizontal: true }}
                                            sx={{ mb: 2, ml: 2, mr: 2 }}
                                            slotProps={{
                                                legend: {
                                                    hidden: true,
                                                }
                                            }}
                                        />
                                        <Stack direction="row" sx={{width: '90%', minHeight: '125px', flexGrow: '1', flexWrap: 'wrap'}}>
                                            {
                                                chartSocialMediaSeriesData.slice(0, defaultLegendItemCountToShow).map((d, idx) => <LegendItem
                                                        color={d.color}
                                                        label={d.label}
                                                    />
                                                )
                                            }
                                            {
                                                showAllSocialMediaLegendItem && chartSocialMediaSeriesData.slice(defaultLegendItemCountToShow).map((d, idx) => <LegendItem
                                                      //  color={colors[idx + defaultLegendItemCountToShow]}
                                                        color={d.color}
                                                        label={d.label}
                                                    />
                                                )
                                            }
                                            <Stack sx={{height: '100%'}}></Stack>
                                        </Stack>
                                        {(chartSocialMediaSeriesData.length > defaultLegendItemCountToShow) ? (
                                            <ListItemButton sx={{fontSize: '12px'}} onClick={() => setShowAllSocialMediaLegendItem(prev => !prev)}>{showAllSocialMediaLegendItem ? 'Minimize Legend View' : 'Expand Legend View'}</ListItemButton>
                                        ):(
                                            <Stack sx={{height: '35px'}}></Stack>
                                        )
                                        }
                                    </Stack>
                                </Stack>
                            </CustomTabPanel>

                            <CustomTabPanel value={selectedTab} index={1}>
                                <Stack direction="row" sx={{ gap: 1, mt: 1.5 }}>
                                    {!(educationQualifications?.loading || educationQualifications?.error) &&
                                        <Stack direction="column" sx={{ width: '100%' }}>
                                            <Stack direction="column" sx={{ mr: 1, mb: 1 }}>
                                                <Typography component="h2" variant="h6">
                                                    <SchoolOutlinedIcon fontSize='large' sx={{ color: 'background.paper', mr: 1 }} />Education
                                                </Typography>
                                            </Stack>
                                            <DataGrid
                                                autoHeight
                                                disableColumnFilter
                                                disableColumnMenu
                                                disableColumnSelector
                                                disableColumnResize
                                                disableRowSelectionOnClick
                                                // hideFooter={true}
                                                rows={educationQualifications?.value?.list}
                                                columns={columnsForEducation}
                                                getRowClassName={(params) =>
                                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                                }
                                                slots={{footer: customFooter}}
                                                initialState={{
                                                    pagination: { paginationModel: { pageSize: 5 } },
                                                }}
                                                pageSizeOptions={[5, 25, 50, 100]}
                                                sx={{
                                                    border: 0,
                                                    '& .MuiDataGrid-row': {
                                                        borderBottom: '1px solid #cccccc',
                                                    },
                                                    '& .MuiDataGrid-topContainer': {
                                                        color: '#fff',
                                                    },
                                                    '& .MuiDataGrid-cell': {
                                                        fontSize: '14px',
                                                    },
                                                    "& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                                                        pt: 2
                                                    },
                                                    "& .MuiSelect-select ": {
                                                        pt: 1
                                                    }
                                                }}
                                                disableSelectionOnClick
                                            />
                                        </Stack>
                                    }
                                </Stack>
                                <Stack direction="row" sx={{ gap: 1, mt: 1.5 }}>
                                    {!(professionalActivities?.loading || professionalActivities?.error) &&
                                        <Stack direction="column" sx={{ width: '100%' }}>
                                            <Stack direction="column" sx={{ mr: 1, mb: 1 }}>
                                                <Typography component="h2" variant="h6">
                                                    <PersonOutlineOutlinedIcon fontSize='large' sx={{ color: 'background.paper', mr: .5 }} /> Professional Roles
                                                </Typography>
                                            </Stack>
                                            <DataGrid
                                                autoHeight
                                                disableColumnFilter
                                                disableColumnMenu
                                                disableColumnSelector
                                                disableColumnResize
                                                disableRowSelectionOnClick
                                                // hideFooter={true}
                                                hideFooterPagination={true}
                                                rows={professionalActivities?.value?.list}
                                                columns={columnsForProfessional}
                                                getRowClassName={(params) =>
                                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                                }
                                                slots={{footer: customFooter}}
                                                initialState={{
                                                    pagination: { paginationModel: { pageSize: 5 } },
                                                }}
                                                pageSizeOptions={[5, 25, 50, 100]}
                                                sx={{
                                                    border: 0,
                                                    '& .MuiDataGrid-row': {
                                                        borderBottom: '1px solid #cccccc',
                                                    },
                                                    '& .MuiDataGrid-topContainer': {
                                                        color: '#fff', // Text color
                                                        // border: 0
                                                    },
                                                    '& .MuiDataGrid-cell': {
                                                        fontSize: '14px',
                                                    },
                                                    "& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                                                        pt: 2
                                                    },
                                                    "& .MuiSelect-select ": {
                                                        pt: 1
                                                    }
                                                }}
                                                disableSelectionOnClick
                                            />
                                        </Stack>
                                    }

                                </Stack>
                                <Stack direction="row" sx={{ gap: 1, mt: 1.5 }}>
                                    {!(honorAndAwards?.loading || honorAndAwards?.error) &&
                                        <Stack direction="column" sx={{ width: '100%' }}>
                                            <Stack direction="column" sx={{ mr: 1, mb: 1 }}>
                                                <Typography component="h2" variant="h6">
                                                    <EmojiEventsOutlinedIcon fontSize='large' sx={{ color: 'background.paper', mr: .5 }} />Achievements
                                                </Typography>
                                            </Stack>
                                            <DataGrid
                                                autoHeight
                                                disableColumnFilter
                                                disableColumnMenu
                                                disableColumnSelector
                                                disableColumnResize
                                                disableRowSelectionOnClick
                                                // hideFooter={true}
                                                hideFooterPagination={true}
                                                rows={honorAndAwards?.value?.list}
                                                columns={columnsForAchievement}
                                                getRowClassName={(params) =>
                                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                                }
                                                initialState={{
                                                    pagination: { paginationModel: { pageSize: 5 } },
                                                }}
                                                pageSizeOptions={[5, 25, 50, 100]}
                                                slots={{footer: customFooter}}
                                                sx={{
                                                    border: 0,
                                                    '& .MuiDataGrid-row': {
                                                        borderBottom: '1px solid #cccccc',
                                                    },
                                                    '& .MuiDataGrid-topContainer': {
                                                        color: '#fff', // Text color
                                                        // border: 0
                                                    },
                                                    '& .MuiDataGrid-cell': {
                                                        fontSize: '14px',
                                                    },
                                                    "& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                                                        pt: 2
                                                    },
                                                    "& .MuiSelect-select ": {
                                                        pt: 1
                                                    }
                                                }}
                                                disableSelectionOnClick
                                            />
                                        </Stack>
                                    }
                                </Stack>
                            </CustomTabPanel>
                            <CustomTabPanel value={selectedTab} index={2}>
                                <Stack direction="column" sx={{
                                    width: '100%',
                                    display: 'flex', mt: 2, gap: 0,
                                    background: '#FFF',
                                    backdropFilter: 'blur(1px)',
                                }}>
                                    <Stack direction="column" padding={1} sx={{ gap: 1, mt: 1 }} >
                                        <Typography component="h6" variant="h6" sx={{ ml: 1 }}>
                                            <FeedIcon fontSize='large' />  Scientific Publications
                                        </Typography>
                                    </Stack>
                                    <Stack direction="column" padding={1} sx={{
                                        gap: 1, mt: 1, mb: 3, width: '100%',
                                    }} >
                                        <Grid container spacing={1} columns={12}>
                                            <Grid size={{ md: 12, lg: 12 }}>
                                                <DataGrid
                                                    autoHeight
                                                    // rowHeight={42}
                                                    // checkboxSelection
                                                    disableColumnFilter
                                                    disableColumnMenu
                                                    disableColumnSelector
                                                    disableColumnResize
                                                    disableRowSelectionOnClick
                                                    // hideFooter={true}
                                                    hideFooterPagination={true}
                                                    rows={publication?.value?.list}
                                                    columns={columnsForPublication}
                                                    getRowClassName={(params) =>
                                                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                                    }
                                                    disableSelectionOnClick
                                                    slots={{footer: customFooter}}
                                                    sx={{
                                                        border: 0,
                                                        '& .MuiDataGrid-row': {
                                                          borderBottom: '1px solid #cccccc',
                                                        },
                                                        '& .MuiDataGrid-topContainer': {
                                                            color: '#fff', // Text color
                                                            // border: 0
                                                        },
                                                        "& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                                                            pt: 2
                                                        },
                                                        "& .MuiSelect-select ": {
                                                            pt: 1
                                                        }
                                                    }}
                                                    initialState={{
                                                        pagination: { paginationModel: { pageSize: 25 } },
                                                    }}
                                                    pageSizeOptions={[10, 25, 50, 100]}
                                                    loading={scientificPubLoading}
                                                    components={{
                                                        LoadingOverlay: CircularProgress,
                                                    }}
                                                    onStateChange={(newState) => {
                                                        if (newState && newState.page) {
                                                            setScientificPubLoading(false);
                                                        }
                                                    }}
                                                    slotProps={{
                                                        loadingOverlay: {
                                                            variant: 'skeleton',
                                                            // noRowsVariant: 'skeleton',
                                                        },
                                                        filterPanel: {
                                                            // filterFormProps: {
                                                            //     logicOperatorInputProps: {
                                                            //         variant: 'outlined',
                                                            //         size: 'small',
                                                            //     },
                                                            //     columnInputProps: {
                                                            //         variant: 'outlined',
                                                            //         size: 'small',
                                                            //         sx: { mt: 'auto' },
                                                            //     },
                                                            //     operatorInputProps: {
                                                            //         variant: 'outlined',
                                                            //         size: 'small',
                                                            //         sx: { mt: 'auto' },
                                                            //     },
                                                            //     valueInputProps: {
                                                            //         InputComponentProps: {
                                                            //             variant: 'outlined',
                                                            //             size: 'small',
                                                            //         },
                                                            //     },
                                                            // },
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                        {/*{(totalPages > 1)  &&*/}
                                        {/*<Pagination variant="outlined" color="primary" count={totalPages}  page={pageFilter.pageNumber} onChange={navigatePage}  />*/}
                                        {/*}*/}
                                    </Stack>
                                    <Stack direction="column" padding={1} sx={{ gap: 1, mt: 1 }} >
                                        <Typography component="h6" variant="h6" sx={{ ml: 1 }}>
                                            <NewspaperOutlinedIcon fontSize='large' />  News
                                        </Typography>
                                    </Stack>
                                    <Stack direction="column" padding={1} sx={{
                                        gap: 1, mt: 1, mb: 3, width: '100%',
                                    }} >
                                        <Grid container spacing={1} columns={12}>
                                            <Grid size={{ md: 12, lg: 12 }}>
                                                <DataGrid
                                                    autoHeight
                                                    // rowHeight={42}
                                                    // checkboxSelection
                                                    disableColumnFilter
                                                    disableColumnMenu
                                                    disableColumnSelector
                                                    disableColumnResize
                                                    disableRowSelectionOnClick
                                                    // hideFooter={true}
                                                    hideFooterPagination={true}
                                                    rows={press?.value?.list}
                                                    columns={columnsForPress}
                                                    getRowClassName={(params) =>
                                                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                                    }
                                                    disableSelectionOnClick
                                                    slots={{footer: customFooter}}
                                                    sx={{
                                                        border: 0,
                                                        '& .MuiDataGrid-row': {
                                                            borderBottom: '1px solid #cccccc',
                                                        },
                                                        '& .MuiDataGrid-topContainer': {
                                                            color: '#fff', // Text color
                                                            // border: 0
                                                        },
                                                        "& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                                                            pt: 2
                                                        },
                                                        "& .MuiSelect-select ": {
                                                            pt: 1
                                                        }
                                                    }}
                                                    initialState={{
                                                        pagination: { paginationModel: { pageSize: 25 } },
                                                    }}
                                                    pageSizeOptions={[10, 25, 50, 100]}
                                                    slotProps={{
                                                        filterPanel: {
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Stack>
                                </Stack >
                            </CustomTabPanel>
                        </Stack>
                    </Stack>
                </Stack>
            )}
        </Box >
    );
}